export default "__VITE_ASSET__9cc59527__"